<template>
    <div id="index">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                    <el-form-item :label="$t('CampusName')">
                        <el-input @keyup.enter.native="selectData" v-model="formselect.FactoryName" class="queryform"
                                  :placeholder="$t('CampusName')"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="selectData" type="primary">{{ $t('Query') }}</el-button>
                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                    </el-form-item>
                </el-form>
                <template>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add"
                               v-if="judge('ElectricPrice_Create')"
                               style="margin-bottom:10px;">{{ $t('Add') }}
                    </el-button>
                    <el-button type="default" @click="createElectricPrice"
                               v-if="judge('ElectricPrice_CreateNextYearElectricPrice')"
                               style="margin-bottom:10px;">{{ $t('BatchGenerateElectricityUnitPrice') }}
                    </el-button>
                    <el-table ref="multipleTable"
                              :data="tableData1"
                              v-loading="loading"
                              border
                              stripe
                              style="width:100%;min-height:200px;">
                        <!--                        <el-table-column fixed="left"-->
                        <!--                                         type="selection"-->
                        <!--                                         width="50">-->
                        <!--                        </el-table-column>-->
                        <el-table-column type="index"
                                         :label="$t('SN')"
                                         width="50">
                        </el-table-column>
                        <el-table-column prop="factoryName"
                                         :label="$t('Campus')"
                                         width="120">
                        </el-table-column>
                        <el-table-column prop="hmlName"
                                         :label="$t('PeakFlatValley')"
                                         min-width="10%">
                        </el-table-column>
                        <el-table-column prop="StartD"
                                         :label="$t('StartDate')"
                                         min-width="15%">
                        </el-table-column>
                        <el-table-column prop="EndD"
                                         :label="$t('EndDate')"
                                         min-width="15%">
                        </el-table-column>
                        <el-table-column prop="StartT"
                                         :label="$t('DailyStartTime')"
                                         min-width="15%">
                        </el-table-column>

                        <el-table-column prop="EndT"
                                         :label="$t('DailyEndTime')"
                                         min-width="15%">
                        </el-table-column>
                        <el-table-column prop="electricityPrice"
                                         :label="$t('UnitPrice')"
                                         min-width="10%">
                        </el-table-column>

                        <el-table-column fixed="right"
                                         :label="$t('Action')"
                                         width="150">
                            <template slot-scope="scope">
                                <el-button v-if="judge('ElectricPrice_Update')" @click="edit(scope.row)" type="primary"
                                           size="small">{{ $t('Edit') }}
                                </el-button>
                                <template v-if="judge('ElectricPrice_Delete')">
                                    <el-popconfirm placement="top"
                                                   :confirmButtonText="$t('Delete')"
                                                   :cancelButtonText="$t('Cancel')"
                                                   @onConfirm="del(scope.row.id)"
                                                   icon="el-icon-info"
                                                   iconColor="red"
                                                   :title="$t('DeleteConfirm')">
                                        <el-button size="mini" type="danger" slot="reference"
                                                   style=" margin-left: 10px;">{{ $t('Delete') }}
                                        </el-button>
                                    </el-popconfirm>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            :page-size="10"
                            @current-change="handleCurrentChange"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>
                </template>
            </el-main>
        </el-scrollbar>

        <el-dialog
                :title="$t('prompt')"
                v-if="ElectricPriceDialog"
                :visible.sync="ElectricPriceDialog"
                width="50%">
            <el-input :placeholder="$t('PleaseEnterTheYear')" type="number" v-model="year"></el-input>
            <span slot="footer" class="dialog-footer">
            <el-button @click="ElectricPriceDialog = false">{{ $t('Cancel') }}</el-button>
            <el-button type="primary" @click="eleSubmit">{{$t('Confirm')}})</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$t('NewElectricityPriceSettings')" v-if="dialogAddPrice" :visible.sync="dialogAddPrice" width="70%" top="10vh">
            <el-form :inline="true" ref="Priceform" :model="Priceform" label-width="150px">
                <el-form-item :label="$t('City')" prop="cityId" :rules="[{required: true, message: $t('PleaseSelectCity')}]">
                    <el-select v-model="Priceform.cityId" @change="getFac('add')" :placeholder="$t('el.select.placeholder')" filterable
                               class="queryform">
                        <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')" prop="factoryId" :rules="[{required: true, message: $t('PleaseSelectThePark')}]">
                    <el-select v-model="Priceform.factoryId" @change="getBuild('add')" :placeholder="$t('el.select.placeholder')" filterable
                               class="queryform">
                        <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('PeakFlatValley')" prop="hmlCode" :rules="[{required: true, message: $t('PleaseSelectPeakFlatValley')}]">
                    <el-select :placeholder="$t('el.select.placeholder')" style="width: 250px;" v-model="Priceform.hmlCode">
                        <el-option value="Peak" :label="$t('Peak')"></el-option>
                        <el-option value="Flat" :label="$t('Flat')"></el-option>
                        <el-option value="Valley" :label="$t('Valley')"></el-option>
                    </el-select>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('StartDate')" prop="StartD" :rules="[{required: true, message: $t('PleaseSelectTheStartDate')}]">
                    <el-date-picker v-model="Priceform.StartD"
                                    :picker-options="startDatepicker"
                                    @focus="clickStartTime"
                                    type="date"
                                    value-format="yyyy/MM/dd"
                                    :placeholder="$t('SelectDate')" style="width: 250px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('EndDate')" prop="EndD" :rules="[{required: true, message: $t('PleaseSelectTheEndDate')}]">
                    <el-date-picker v-model="Priceform.EndD"
                                    type="date"
                                    @focus="clickEndTime"
                                    :picker-options="endDatepicker"
                                    value-format="yyyy/MM/dd"
                                    :placeholder="$t('SelectDate')" style="width: 250px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('DailyStartTime')" prop="StartT" :rules="[{required: true, message: '请选择每日开始时间'}]">
                    <el-time-picker
                            v-model="Priceform.StartT"
                            :picker-options="{
                                selectableRange: '00:00:00 - 23:59:59'
                            }"
                            @change="setEndT"
                            format="HH:mm:ss"
                            value-format="HH:mm:ss"
                            style="width: 250px;">
                    </el-time-picker>
                </el-form-item>
                <el-form-item :label="$t('DailyEndTime')" prop="EndT" :rules="[{required: true, message: $t('PleaseSelectDailyStartTime')}]">
                    <el-time-picker
                            :picker-options="{
                                      selectableRange: Priceform.StartT+' - 23:59:59'
                                    }"
                            v-model="Priceform.EndT"
                            format="HH:mm:ss"
                            value-format="HH:mm:ss"
                            style="width: 250px;">
                    </el-time-picker>
                </el-form-item>
                <el-form-item :label="$t('ElectricityPrice')" prop="electricityPrice" :rules="[{required: true, message: $t('PleaseSelectTheInputElectricityPrice')}]">
                    <el-input style="width: 250px;" v-model="Priceform.electricityPrice"></el-input>
                </el-form-item>

                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" @click="onSubmit('Priceform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogAddPrice = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
    import {
        GetAllElectricPrice,
        CreateNextYearElectricPrice,
        CreateElectricPrice,
        DeleteElectricPrice,
        UpdateElectricPrice
    } from '../../api/api'
    import {mapState} from 'vuex';
    import {fancha, getISOtime, getLocalTime} from '../../utils/util'
    import {judgePermission} from '../../utils/util'

    export default {
        name: "electrovalence",
        data() {
            return {
                year: '',
                startDatepicker: {},
                endDatepicker: {},
                ElectricPriceDialog: false,
                formselect: {
                    FactoryName: "",
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: ""
                },
                area: JSON.parse(sessionStorage.getItem("area")),
                formArea: {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""},
                facList: [],
                building: [],
                labList: [],
                deviveList: [],
                total: 0,
                loading: false,
                dialogAddPrice: false,
                tableData1: [],
                Priceform: {
                    pack: '',
                    id: "",
                    cityId: "",
                    factoryId: "",
                    hmlCode: '',
                    StartD: '',
                    EndD: '',
                    StartT: '',
                    EndT: '',
                    electricityPrice: '',
                },
                country: [{
                    value: '1',
                    label: '中国'
                }],
                city: [
                    {
                        value: '1',
                        label: '上海'
                    }, {
                        value: '2',
                        label: '南京'
                    }, {
                        value: '3',
                        label: '杭州'
                    }],
                pack: [
                    {
                        value: '1',
                        label: '金桥'
                    }, {
                        value: '2',
                        label: '西藏北路'
                    }],
                currentPage: 0,
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            eleSubmit() {
                if (this.year) {
                    var that = this
                    CreateNextYearElectricPrice(parseInt(this.year)).then(res => {
                        if (res.success) {
                            that.$message.success(this.$t('BatchAdditionSuccessful'))
                            that.ElectricPriceDialog = false
                            that.getData()
                        }
                    })
                } else {
                    this.$message.error(this.$t('PleaseEnterTheYear'))
                    return;
                }
            },
            createElectricPrice() {
                this.ElectricPriceDialog = true
                this.year = new Date().getFullYear()
            },
            clickStartTime() {
                this.startDatepicker.disabledDate = time => {
                    if (this.Priceform.EndD) {
                        if (time.getTime() > new Date(this.Priceform.EndD).getTime()) {
                            return true
                        }
                        // if (time.getTime() < Date.now() - 8.64e7) {
                        //     return true
                        // }
                    } else {
                        // if (time.getTime() < Date.now() - 8.64e7) {
                        //     return true
                        // }
                    }
                }
            },
            clickEndTime() {
                this.endDatepicker.disabledDate = time => {
                    if (this.Priceform.StartD) {
                        return (
                            time.getTime() < new Date(this.Priceform.StartD).getTime()
                        )
                    } else {
                        // return time.getTime() < Date.now()
                    }
                }
            },
            setEndT() {
                if (this.Priceform.StartT > this.Priceform.EndT) {
                    this.Priceform.EndT = this.Priceform.StartT
                }
            },
            beginDate() {
                const self = this
                return {
                    disabledDate(time) {
                        if (self.Priceform.EndT) {  //如果结束时间不为空，则小于结束时间
                            return new Date(self.Priceform.EndT).getTime() < time.getTime()
                        } else {
                            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
                        }
                    }
                }
            },
            processDate() {
                const self = this
                return {
                    disabledDate(time) {
                        if (self.Priceform.StartT) {  //如果开始时间不为空，则结束时间大于开始时间
                            return new Date(self.Priceform.StartT).getTime() > time.getTime()
                        } else {
                            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
                        }
                    }
                }
            },
            judge(e) {
                return judgePermission(e)
            },
            getFac(e) {
                var a = '', id = e == 'add' ? this.Priceform.cityId : this.formselect.cityId
                this.area.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })

                this.facList = this.area[a].children
                this.formselect = {...this.formselect, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.Priceform = {...this.Priceform, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
            },
            getBuild(e) {
                var a = '', id = e == 'add' ? this.Priceform.factoryId : this.formselect.factoryId
                this.facList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.building = this.facList[a].children
                this.formselect = {...this.formselect, ...{buildingId: "", LabId: "", deviceId: ""}}
                this.Priceform = {...this.Priceform, ...{buildingId: "", LabId: "", deviceId: ""}}
            },
            getLab(e) {
                var a = '', id = e == 'add' ? this.Priceform.buildingId : this.formselect.buildingId
                this.building.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.labList = this.building[a].children
                this.formselect = {...this.formselect, ...{LabId: "", deviceId: ""}}
                this.Priceform = {...this.Priceform, ...{LabId: "", deviceId: ""}}
            },
            getDevide(e) {
                var a = '', id = e == 'add' ? this.Priceform.LabId : this.formselect.LabId
                this.labList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.deviveList = this.labList[a].children
                this.formselect = {...this.formselect, ...{deviceId: ""}}
                this.Priceform = {...this.Priceform, ...{deviceId: ""}}
            },

            selectData() {
                this.currentPage = 0
                this.getData()
            },
            //查询重置
            reset() {
                this.currentPage = 0
                this.formselect = {
                    FactoryName: "",
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: ""
                }
                this.getData()
            },
            //分页
            handleCurrentChange(val) {
                this.currentPage = (val - 1) * 10
                this.getData()
            },
            //获取数据列表
            getData() {
                this.loading = true
                var data = {
                    currentPage: this.currentPage,
                    factoryName: this.formselect.FactoryName,
                }, that = this
                GetAllElectricPrice(data).then(res => {
                    if (res.success) {
                        that.tableData1 = res.result.items
                        this.loading = false
                        that.tableData1.map(i => {
                            i.StartD = getLocalTime(i.startDate).substring(0, 10)
                            i.EndD = getLocalTime(i.endDate).substring(0, 10)
                            i.StartT = getLocalTime(i.startDate).substring(11)
                            i.EndT = getLocalTime(i.endDate).substring(11)
                        })
                        that.total = res.result.totalCount
                    }
                })
            },
            //删除
            del(e) {
                var that = this
                DeleteElectricPrice(e).then(res => {
                    if (res.success) {
                        that.$message.success(this.$t('deleteSuccessful'))
                        that.getData()
                    } else {
                        that.$message.error(this.$t('DeleteFailed'))
                    }
                })
            },
            //新增
            add() {
                this.dialogAddPrice = true
                this.clickBtn = 'add'
                this.Priceform = {
                    pack: '',
                    id: "",
                    cityId: "",
                    factoryId: "",
                    hmlCode: '',
                    StartD: '',
                    EndD: '',
                    StartT: '00:00:00',
                    EndT: '00:00:00',
                    electricityPrice: '',
                }
            },
            //编辑
            edit(e) {
                var data = fancha(e.factoryId)
                this.Priceform.cityId = this.area[data[0]].value
                this.facList = this.area[data[0]].children

                this.dialogAddPrice = true
                this.Priceform.id = e.id
                this.Priceform.factoryId = e.factoryId
                this.Priceform.hmlCode = e.hmlCode
                this.Priceform.electricityPrice = e.electricityPrice
                this.$set(this.Priceform, 'StartT', e.StartT)
                this.$set(this.Priceform, 'EndT', e.EndT)
                this.$set(this.Priceform, "StartD", e.StartD.replace(/-/g, '/'))
                this.$set(this.Priceform, "EndD", e.EndD.replace(/-/g, '/'))
                this.clickBtn = 'edit'
            },
            getLocalTime(e) {
                var dateee = new Date(e).toJSON();
                var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
                return date
            },
            //时间格式转换 西八区+8
            getISOtime(e) {
                var time = new Date(e).getTime() + 8 * 60 * 60 * 1000
                var date = new Date(time)
                var result = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
                return new Date(result).toISOString()
            },
            onSubmit(Priceform) {
                this.$refs[Priceform].validate(async valid => {
                    if (valid) {
                        var startDate = `${this.Priceform.StartD} ${this.Priceform.StartT}`
                        var endDate = `${this.Priceform.EndD} ${this.Priceform.EndT}`
                        var data = {
                            id: this.Priceform.id,
                            startDate: getISOtime(startDate),
                            endDate: getISOtime(endDate),
                            factoryId: this.Priceform.factoryId,
                            electricityPrice: this.Priceform.electricityPrice,
                            hmlCode: this.Priceform.hmlCode,
                        }, that = this
                        if (this.Priceform.StartT > this.Priceform.EndT) {
                            this.$message.warning(this.$t('dailyEndTime'))
                            return false;
                        }
                        if (!this.Priceform.hmlCode || !this.Priceform.electricityPrice || !data.startDate || !data.endDate || !this.Priceform.factoryId) {
                            this.$message.warning(this.$t('PleaseFillItOutCompletely'))
                            return false;
                        }
                        if (this.clickBtn == 'add') {
                            delete data.id
                            CreateElectricPrice(data).then(res => {
                                if (res.success) {
                                    that.$message.success(this.$t('Creation'))
                                    that.getData()
                                    that.dialogAddPrice = false
                                } else {
                                    that.$message.error(this.$t('CreationFailed'))
                                }
                            }).catch(err => {
                                that.$message.error(err.error.message)
                            })
                        } else {
                            UpdateElectricPrice(data).then(res => {
                                if (res.success) {
                                    that.$message.success(this.$t('Update'))
                                    that.dialogAddPrice = false
                                    that.getData()
                                } else {
                                    that.$message.success(this.$t('UpdateFailed'))
                                }
                            }).catch(err => {
                                that.$message.error(err.error.message)
                            })
                        }
                    }
                })
            },

        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>

</style>
